import {createContext} from "react";

export const RecordeeContext = createContext()